import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "./useAppStore";
import { fetchUptimeDashboard } from "../store/slices/uptimeSlice";

export function useStatusPage() {
  const dispatch = useAppDispatch();
  const { apiSeries, allianceList, loading, error } = useAppSelector(
    (state) => state.uptime,
  );

  useEffect(() => {
    dispatch(fetchUptimeDashboard());
  }, [dispatch]);

  return { apiSeries, allianceList, loading, error };
}
